import React, { useMemo } from 'react';
import Select from 'react-select';
import styles from './MyOrdersPage.module.css';

import type {
  IOrderStatusFilterDropdownProps,
  OrderStatusOption,
} from '@model/OrdersHistory.model';
import { ORDER_STATUS_OPTIONS } from '../../../Model/OrdersHistory.model';
import { OrderService } from '../../../Logic/OrderService';

const OrderStatusFilterDropdown: React.FC<IOrderStatusFilterDropdownProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const service = new OrderService();

  const selectedOptions = useMemo(() => service.getSelectedStatusOptions(value), [service, value]);

  return (
    <div className={styles.filterDropdown} data-testid="order-status-filter">
      <Select<OrderStatusOption, true>
        isMulti
        isDisabled={disabled}
        options={ORDER_STATUS_OPTIONS}
        value={selectedOptions}
        onChange={(vals) => onChange((vals ?? []).map((v) => v.value))}
        placeholder="Status: All"
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        className={styles.selectRoot}
        classNamePrefix="filterSelect"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        data-testid="order-status-filter-select"
        inputId="order-status-filter-input"
      />
    </div>
  );
};

export default OrderStatusFilterDropdown;
